import config from "@/config";
import type { LinkedWorkflowsSearchBody } from "@/util/linkedWorkflows";
import { requests } from ".";

const segment = (value: string) => encodeURIComponent(value);

/**
 * Workflow endpoints the Connections pane calls directly with the builder's token-id.
 * locationId always comes from the host handshake (app store), never from user input.
 * Any 2xx is success -- staging answers the search with 201.
 */
export const WorkflowServices = {
  searchLinked: async (
    body: LinkedWorkflowsSearchBody,
    signal?: AbortSignal
  ): Promise<unknown> => {
    const { data } = await requests(config?.WORKFLOW_SEARCH_URL).post(
      "/workflows/es/search",
      body,
      { signal }
    );
    return data;
  },
  rename: (locationId: string, workflowId: string, name: string) =>
    requests(config?.WORKFLOW_SERVER_URL).put(
      `/${segment(locationId)}/rename-workflow/${segment(workflowId)}`,
      { name }
    ),
  // Soft delete through the same bulk endpoint the workflow list uses; the actor comes from auth
  remove: (locationId: string, workflowId: string) =>
    requests(config?.WORKFLOW_SERVER_URL).delete(`/${segment(locationId)}/delete`, {
      data: { type: "workflow", workflowIds: [workflowId] },
    }),
};
